var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_359_42324)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22,
    fill: "#00E88F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3364 38.2973C22.8532 38.2973 22.4614 37.8835 22.4614 37.373L22.4614 32.4434C22.4614 31.9329 22.8532 31.5191 23.3364 31.5191C23.8197 31.5191 24.2114 31.9329 24.2114 32.4434L24.2114 36.4487H28.0031C28.4863 36.4487 28.8781 36.8625 28.8781 37.373C28.8781 37.8835 28.4863 38.2973 28.0031 38.2973H23.3364Z",
    fill: "#191A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1345 21.8257C37.6177 21.8257 38.0095 22.2395 38.0095 22.75V27.6796C38.0095 28.1901 37.6177 28.6039 37.1345 28.6039C36.6512 28.6039 36.2595 28.1901 36.2595 27.6796V23.6743H32.4678C31.9846 23.6743 31.5928 23.2605 31.5928 22.75C31.5928 22.2395 31.9846 21.8257 32.4678 21.8257H37.1345Z",
    fill: "#191A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5486 22.3599C37.864 22.6931 37.864 23.2334 37.5486 23.5665L24.6255 37.2178C24.3101 37.551 23.7987 37.551 23.4832 37.2178C23.1678 36.8846 23.1678 36.3444 23.4832 36.0112L36.4063 22.3599C36.7217 22.0267 37.2331 22.0267 37.5486 22.3599Z",
    fill: "#191A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_359_42324",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_359_42324"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_359_42324",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsed);
export default __webpack_public_path__ + "static/media/Collapsed.9dc1f0d03718244e08bcd9d0ce2407a9.svg";
export { ForwardRef as ReactComponent };